/** @graphql cc **/
import gql from 'graphql-tag';

export const LicensedProductsQuery = gql`
	query LicensedProductsQuery {
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
	}
`;
